// import { useState } from "react";
import { Button, Menu, Affix } from "antd";
import { FC, useEffect, useState, useMemo } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "assets/images/logoSvg.svg";
import { IMenu, menuList } from "./menuList";
import { useAppDispatch, useAppSelector } from "store";
import { sigOut } from "store/slices/authSlice";
import packageJson from "../../package.json";
import FactorySetupBrandButton from "components/Profiles/SettingFactory/FactorySetupBrandButton";
import useFactorySetupNeeded from "components/Profiles/SettingFactory/useFactorySetupNeeded";

interface SidenavProps {
  color?: string;
}



const Sidenav: FC<SidenavProps> = () => {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const { contact } = useAppSelector((state) => state.auth);
  /* ยังตั้งค่าไม่ครบ = ช่องนี้ว่างอยู่แล้ว เอาไปเป็นทางกลับเข้า dialog แทนกรอบรูปแตก */
  const needsFactorySetup = useFactorySetupNeeded();
  const [menuListAvailable, setMenuListAvailable] = useState<IMenu[]>(menuList);

  const dispatch = useAppDispatch();

  //list memu ที่ lunganek ไม่ใช้งาน
  const menuListNotAvailableLunganek = [
    "สร้างคำสั่งซื้อสินค้า",
    "การจัดส่ง",
    "จัดการ Point",
    "ใบกำกับภาษี",
    //"การเงิน",
    //"ลูกค้า"
  ];

  useMemo(() => {
    if (contact?.code === "lunganek") {
      setMenuListAvailable(menuList);
    } else {
      setMenuListAvailable(menuList.filter((menu) => !menuListNotAvailableLunganek.includes(menu.title)));
    }
  }, [contact?.code, menuList]);



  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }} >
      <div style={{}}>
        {needsFactorySetup ? (
          <FactorySetupBrandButton />
        ) : (
          <div className="brand">
            <img src={contact?.image_url} alt="" height={70} />
            <span>{contact?.name}</span>
          </div>
        )}
        <hr />
        <Menu theme="light" mode="inline" defaultSelectedKeys={["1"]}   >
          {menuListAvailable.map((menu) => (
            <Menu.Item key={menu.key}  >
              {menu.isExternal ? (
                <a href={menu.path} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <span
                    className="icon"
                    style={{
                      background: page === `${menu.path}` ? "" : "",
                      ...(menu.iconStyle || {})
                    }}
                  >
                    {menu.icon}
                  </span>
                  <span className="label" style={menu.style || {}}>
                    {menu.title}
                  </span>
                </a>
              ) : (
                <NavLink to={menu.path} >
                  <span
                    className="icon"
                    style={{
                      background: page === `${menu.path}` ? "" : "",
                      ...(menu.iconStyle || {})
                    }}
                  >
                    {menu.icon}
                  </span>
                  <span className="label" style={menu.style || {}}>
                    {menu.title}
                  </span>
                </NavLink>
              )}
            </Menu.Item>
          ))}
        </Menu>
      </div>

      <div style={{ fontSize: 8, color: "gray" }}>
        version {packageJson.version}
      </div>
    </div>
  );
};

export default Sidenav;
